import '../oidc-config/oidc-config';
import '../vendor/custom-oidc-token-manager';

(function () {

    var init = function (script) {

        var appName = 'my';
        var loc = window.location;

        if (!window.TLRAPP || !window.TLRAPP.OIDC || !window.TLRAPP.OIDC.TokenManager || !window.TLRAPP.OIDC.Config) {
            // TODO
            return;
        }

        var config = window.TLRAPP.OIDC.Config;
        var tm = window.TLRAPP.OIDC.TokenManager;

        // Do we have id_token in the URL?
        if (loc.hash && loc.hash.match(/id_token/)) {
            // Yes. Start the app, and let it handle the token
            bootstrap(appName);
        // Do we have login_hint in the URL?
        } else if (loc.hash && loc.hash.match(/login_hint/)) {
            // Yes, grab the login hint param;
            var login_hint = loc.hash.match(/[?&]login_hint=([^&]*)?/)[1];
            // Set login_hint in OIDC_CONFIG
            config['login_hint'] = login_hint;
            var mgr = new tm(config);
            mgr.redirectForToken();
        } else {
            // No, so try and initialise the token manager script
            var mgr = new tm(config);
            // Store the URL that was requested
            var url = loc.hash.replace('#!/', '');
            if (window.sessionStorage) {
                window.sessionStorage.tlrIdentityRedirectRouteUrl =  url;
            }
            // Check for token...
            if (!mgr._token) {
                // ... no token, so redirect to accounts
                // redirect to accounts
                mgr.redirectForToken();
            } else {
                // ... have a token, so start our app
                bootstrap(appName);
            }
        }

        function bootstrap (app) {
            $LAB
                .script(script[0]).wait()
                .script(script[1]);
        }

    };

    window.TLRAPP = window.TLRAPP || {};
    window.TLRAPP.init = init;

})();